<template>
  <div>
    <el-dialog
      :title="this.isCreated ? `新增成就配置` : `编辑成就配置`"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="701px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        size="mini"
        style="margin-right: 50px"
      >
        <el-form-item label="成就类型：" prop="type">
          <el-input
            placeholder="随便填，只要客户端能够识别就行"
            style="width: 520px"
            v-model="form.type"
          ></el-input>
        </el-form-item>
        <el-form-item label="成就参数：" prop="type">
          <el-input
            placeholder="随便填，只要客户端能够识别就行"
            style="width: 520px"
            v-model="form.params"
          ></el-input>
        </el-form-item>        
        <el-form-item label="奖励：">
          <base-item-selector
            @updated="updatedItemSelector"
            v-model="form.rewards"
          ></base-item-selector>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const util = require("@/util");
import BaseItemSelector from "@/pages/activity/activity_parameter_template/biz-components/BaseItemSelector";

// 本弹窗名称
const DialogName = "EditWishActivityAchievementDialog";

export default {
  data() {
    return {
      form: {
        type: "",
        params: "",
        rewards: [],
      },
      isCreated: false,
      itemSelectorResult: [],
    };
  },

  async created() {
    let value = this.$dialogutil.getData(DialogName);
    if (value.entry != null) {
      this.form = value.entry;
    }
    this.isCreated = value.isCreated;
  },

  components: {
    BaseItemSelector,
  },

  methods: {
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async submit() {
      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认新增（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();
        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.closeWithParam(param);
      } catch (e) {}
    },

    async update() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认修改（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();

        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.closeWithParam(param);
      } catch (e) {}
    },

    save() {
      let type = this.form.type.trim();
      if (type == "") {
        return { errMsg: "请正确填写'成就类型'" };
      }

      if (this.itemSelectorResult.errMsg) {
        return { errMsg: this.itemSelectorResult.errMsg };
      }
      let rewards = this.itemSelectorResult;
      if (rewards.length == 0) {
        return { errMsg: "奖励最少配置一项" };
      }

      return {
        type: type,
        params: this.form.params,
        rewards: rewards,
      };
    },

    async updatedItemSelector(param) {
      this.itemSelectorResult = param;
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },

    closeWithParam(param) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName, param);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

